import {
    GET_ALL_PARTICIPANTS,
    ADD_PARTICIPANT,
    EDIT_PARTICIPANT,
    DELETE_PARTICIPANT,
    GET_PARTICIPANTS
} from '../actions/ParticipantActions'
import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'participants',
    storage,
};

const initialState = {
    data: [],
    allParticipants: [],
    totalParticipants: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',

    participants: {
        registered: null,
        checkedIn: null,
    }
}

const ParticipantReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_PARTICIPANT: {
            let tempArray = Object.assign({}, state.allParticipants)
            tempArray.rows = [action.payload, ...state.allParticipants.rows]
            return {
                ...state,
                allParticipants: tempArray,
            }
        }
        case EDIT_PARTICIPANT: {
            let tempArray = Object.assign({}, state.allParticipants)
            let target = tempArray.rows.findIndex(item => { return item.id == action.payload.id })
            tempArray.rows[target] = action.payload
            return {
                ...state,
                allParticipants: tempArray,
            }
        }
        case DELETE_PARTICIPANT: {
            let tempArray = Object.assign({}, state.allParticipants)
            let newArray = tempArray.rows.filter(item => { return item.id !== action.payload })
            tempArray.rows = newArray
            return {
                ...state,
                allParticipants: tempArray,
            }
        }
        case GET_ALL_PARTICIPANTS: {
            return {
                ...state,
                data: action.payload.participants.participants,
                currentPage: action.payload.participants.currentPage,
                totalParticipants: action.payload.participants.totalElements,
                totalPages: action.payload.participants.totalPages,
            }
        }
        case GET_PARTICIPANTS: {
            return {
                ...state,
                participants: {
                    ...state.participants,
                    [action.payload.key]: action.payload.participants
                }
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, ParticipantReducer);
